export const transactionUnitTypes = {
  Quantity: 'Quantity',
  Cash: 'Cash',
};

export const transactionUnitTypesArray = ['Quantity', 'Cash'];

export const transactionTypes = {
  BuyforStorage: 'BuyforStorage', // 1
  BuyforDeliveryOrder: 'BuyforDeliveryOrder', // 2
  BuyforDeliveryDelivery: 'BuyforDeliveryDelivery', // 3
  SellfromStorage: 'SellfromStorage', // 4
  DeliveryfromStorage: 'DeliveryfromStorage', // 5
  PositionIn: 'PositionIn', // 6
  PositionOut: 'PositionOut', // 7
  StorageFee: 'StorageFee', // 8
  CheckDeposit: 'CheckDeposit', // 9
  WireDeposit: 'WireDeposit', // 10
  AchDeposit: 'AchDeposit', // 11
  AchDepositRejection: 'AchDepositRejection', // 12
  CheckDepositRejection: 'CheckDepositRejection', // 13
  WireWithdrawalRejection: 'WireWithdrawalRejection', // 14
  WireWithdrawalFeeRejection: 'WireWithdrawalFeeRejection', // 15
  GenericDeposit: 'GenericDeposit', // 16
  IraDeposit: 'IraDeposit', // 17
  IraFeeDeposit: 'IraFeeDeposit', // 18
  CheckWithdrawal: 'CheckWithdrawal', // 19
  WireWithdrawal: 'WireWithdrawal', // 20
  WireWithdrawalFee: 'WireWithdrawalFee', // 21
  GenericWithdrawal: 'GenericWithdrawal', // 22
  IraTransfer: 'IraTransfer', // 23
  IraDistribution: 'IraDistribution', // 24
  IraFeeWithdrawal: 'IraFeeWithdrawal', // 25
  AipBuy: 'AipBuy', // 26
  AipSell: 'AipSell', // 27
  AipAllocation: 'AipAllocation', // 28
  InKindTransferOut: 'InKindTransferOut', // 29
  InKindTransferIn: 'InKindTransferIn', // 30
  IraFeeDepositRejection: ' IraFeeDepositRejection', // 31
  StorageFeePayment: 'StorageFeePayment', // 32
  CreditCardChagreback: 'CreditCardCargeBack', // 33
  CreditCardRefund: 'CreditCardRefund', // 34
  // Placeholders for backend transaction types 35–38. Their real enum names are
  // TBD from the backend; they only exist so `parseEnumType` (index - 1) lands
  // SellFromHome at index 38, making backend Type 39 map to 'SellFromHome'.
  ReservedType35: 'ReservedType35',
  ReservedType36: 'ReservedType36',
  ReservedType37: 'ReservedType37',
  ReservedForTargetOrders: 'ReservedForTargetOrders', // 38
  SellFromHome: 'SellFromHome', // 39
  // Placeholders for backend transaction types 40-42 (names TBD), same reason
  // as 35-37 above: they keep TriggerOrderBuy at index 42 (backend Type 43).
  ReservedType40: 'ReservedType40',
  ReservedType41: 'ReservedType41',
  ReservedType42: 'ReservedType42',
  TriggerOrderBuy: 'TriggerOrderBuy', // 43
  TriggerOrderSell: 'TriggerOrderSell', // 44
  TriggerOrderReserved: 'TriggerOrderReserved', // 45
  TriggerOrderReservationReleased: 'TriggerOrderReservationReleased', // 46
};

export const transactionTypesArray = Object.keys(transactionTypes);

export const transactionOrderTypes = {
  BuyForStorage: 'BuyForStorage', // 1
  BuyForDeliveryOrder: 'BuyForDeliveryOrder', // 2
  BuyForDeliveryDelivery: 'BuyForDeliveryDelivery', // 3
  SellFromStorage: 'SellFromStorage', // 4
  DeliveryFromStorage: 'DeliveryFromStorage', // 5
  PositionIn: 'PositionIn', // 6
  PositionOut: 'PositionOut', // 7
  StorageFee: 'StorageFee', // 8
  CheckDeposit: 'CheckDeposit', // 9
  WireDeposit: 'WireDeposit', // 10
  AchDeposit: 'AchDeposit', // 11
  AchDepositRejection: 'AchDepositRejection', // 12
  CheckDepositRejection: 'CheckDepositRejection', // 13
  WireWithdrawalRejection: 'WireWithdrawalRejection', // 14
  WireWithdrawalFeeRejection: 'WireWithdrawalFeeRejection', // 15
  GenericDeposit: 'GenericDeposit', // 16
  IraDeposit: 'IraDeposit', // 17
  IraFeeDeposit: 'IraFeeDeposit', // 18
  CheckWithdrawal: 'CheckWithdrawal', // 19
  WireWithdrawal: 'WireWithdrawal', // 20
  WireWithdrawalFee: 'WireWithdrawalFee', // 21
  GenericWithdrawal: 'GenericWithdrawal', // 22
  IraTransfer: 'IraTransfer', // 23
  IraDistribution: 'IraDistribution', // 24
  IraFeeWithdrawal: 'IraFeeWithdrawal', // 25
  AipBuy: 'AipBuy', // 26
  AipSell: 'AipSell', // 27
  AipAllocation: 'AipAllocation', // 28
  InKindTransferOut: 'InKindTransferOut', // 29
  InKindTransferIn: 'InKindTransferIn', // 30
  IraFeeDepositRejection: 'IraFeeDepositRejection', // 31
  StorageFeePayment: 'StorageFeePayment', // 32
  CreditCardChagreback: 'CreditCardCargeBack', // 33
  CreditCardRefund: 'CreditCardRefund', // 34
};

export const TT_BUY_FOR_DELIVERY = 'BuyForDelivery';
export const DELIVER_FROM_STORAGE = 'DeliverFromStorage';
export const FRACTIONAL_CONVERSION = 'FractionalConversion';

export const STORAGE_FEE_PAYMENT = 32;
export const SELL_FROM_HOME = 39;

export const iraFeeWithdrawalTypes = {
  IRAFeeCheckWithdrawal: 'IRAFeeCheckWithdrawal',
  IRAFeeWireWithdrawal: 'IRAFeeWireWithdrawal',
};

export const transactionStatusTypes = {
  PendingExecution: 'PendingExecution', // 1
  NotExecuted: 'NotExecuted', // 2
  PartiallyExecuted: 'PartiallyExecuted', // 3
  Executed: 'Executed', // 4
  PendingFineWeight: 'PendingFineWeight', // 5
  Settled: 'Settled', // 6
  Canceled: 'Canceled', // 7
  PendingShipment: 'PendingShipment', // 8
  PendingPickUp: 'PendingPickUp', // 9
  Shipped: 'Shipped', // 10
  Returned: 'Returned', // 11
  PendingSettlementOfBuy: 'PendingSettlementOfBuy', // 12
  PendingExecutionOfBuy: 'PendingExecutionOfBuy', // 13
  Completed: 'Completed', // 14
  Pending: 'Pending', // 15
  CompletedOnHold: 'CompletedOnHold', // 16
  Rejected: 'Rejected', // 17
  PaidInFull: 'PaidInFull', // 18
  PartiallyPaid: 'PartiallyPaid', // 19
  PendingPayment: 'PendingPayment', // 20
  InGracePeriod: 'InGracePeriod', // 21
  InternalError: 'InternalError', // 22
  RequestSubmitted: 'RequestSubmitted', // 23
  InTransit: 'InTransit', // 24
  PendingVerification: 'PendingVerification', // 25
  VerificationPassed: 'VerificationPassed', // 26
  VerificationFailed: 'VerificationFailed', // 27
  RequestCancelled: 'RequestCancelled', // 28
  PendingSettlement: 'PendingSettlement', // 29
  Expired: 'Expired', // 30
};

export const transactionStatusTypesArray = Object.keys(transactionStatusTypes);

export const tranactionRequiestStatusTypes = {
  Pending: 'Pending', // 1
  Completed: 'Completed', // 2
  Canceled: 'Canceled', // 3
  Failed: 'Failed', // 4
  OnHold: 'OnHold', // 5
  CompletedOnHold: 'CompletedOnHold', // 6
  Returned: 'Returned', // 7
  None: 'None', // 8
  Acknowledged: 'Acknowledged', // 9
  Rejected: 'Rejected', // 10
  PendingBankVerification: 'PendingBankVerification', // 11
};

export const transactionRequiestStatusTypesArray = Object.keys(
  tranactionRequiestStatusTypes,
);

// The transactions/transaction-requests response's TriggerOrderStatus field
// has different meanings from RequestStatus above at the same numeric values,
// so it needs its own enum (note the gap at 2 — not used by the backend).
export const triggerOrderStatusTypesArray = [
  'Active', // 1
  '', // 2
  'Triggered', // 3
  'Failed', // 4
  'Cancelled', // 5
  'Expired', // 6
];

export const TRANSACTION_REQUEST_TYPE_TRIGGER_ORDER = 2;

// The `type` the single transaction API takes (?type=) for a Target Price Order,
// whose TriggerOrderUid is not a regular transaction's uid.
export const SINGLE_TRANSACTION_TYPE_TRIGGER_ORDER = 'TriggerOrder';

export const transactionFormatTypes = [
  'Address',
  'Currency',
  'Date',
  'DateRange',
  'DateTime',
  'Decimal',
  'Divider',
  'Memo',
  'Product',
  'ProductImage',
  'String',
  'TrackingNumbers',
  'TransactionIcon',
  'TransactionStatus',
  'TransactionSummary',
  'CustomCaption', // 16: a row the BE words itself (CustomCaption and Value)
];

export const transactionCaptionTypes = [
  'BankAccountNickname',
  'ACHTraceNumber',
  'Address',
  'Amount',
  'BalanceDue',
  'BankName',
  'CheckNumber',
  'ClearingDate',
  'DeliveryFee',
  'DueDate',
  'FederalReferenceNumber',
  'Icon',
  'InvoicePeriod',
  'Message',
  'Notes',
  'OrderTotal',
  'PricePerOz',
  'PricePerUnit',
  'Product',
  'Quantity',
  'QuantityExecuted',
  'ReceivedOn',
  'ReferenceNumber',
  'RelatedReferenceNumber',
  'RoutingNumber',
  'SalesTax',
  'Status',
  'Submitter',
  'Summary',
  'TrackingNumbers',
  'TransactedOn',
  'Valuation',
  'SettlementDate',
  'AvailableOn',
  'CreditCardType',
  'CreditCardLastFourDigits',
  'TransactionID',
  'ShipmentReleaseDate',
  'ShippingFee', // 39
  'ShippingInsuranceFee', // 40
  'CreditCardAuthorizedAmount', // 41
  // PriceAlerts (Target Price order) captions, appended after the SFH ones.
  'TargetPriceId', // 42
  'TargetPrice', // 43
  'ReservedAmount', // 44
  'SubmittedOn', // 45
  'ExpiresOn', // 46
];

export const trackingNumberCourierType = ['Fedex', 'DHL', 'UPS', 'USPS'];

export const transactionTypeByKey = {
  TransactionType: transactionTypesArray,
  UnitType: transactionUnitTypesArray,
  FormatType: transactionFormatTypes,
  CaptionType: transactionCaptionTypes,
};
